export const personalDetails = {
  personalDetails: "Personal Details",
  changeAvatar: "Change Avatar",
  changeLogo: "Change Logo",
  logoFormat: "File formats: PNG, JPEG, GIF",
  personalInformation: "Personal Information",
  name: "Name",
  nationality: "Nationality",
  dateOfBirth: "Date of Birth",
  gender: "Gender",
  phoneNumber: "Phone Number",
  email: "Email",
  address: "Address",
  personalInformationCountry: "Country of Residence",
  personalInformationCity: "City of Residence",
  Availability: "Availability",
  timeZone: "Time Zone",
  availableTime: "Available Time (From/To)",
  emergencyContact: "Emergency Contact",
  relationship: "Relationship",
  alternativePhoneNumber: "Alternate Phone",
  firstName: "First Name",
  lastName: "Last Name",
  availabilityUpdated: "Availability updated successfully",
  personalDetailsUpdated: "Personal details updated successfully",
  emergencyContactUpdated: "Emergency contact updated successfully",
  // Agency Company Details
  companyDetails: "Company Details",
  companyInformation: "General Information",
  editCompanyInformation: "Edit Company Information",
  companyName: "Company Name",
  representativeName: "Representative Name",
  companyWebsite: "Company Website",
  country: "Country",
  city: "City",
  enterCompanyName: "Enter company name",
  enterRepresentativeName: "Enter representative name",
  enterEmail: "Enter email address",
  enterPhoneNumber: "Enter phone number",
  selectCountry: "Select country",
  selectCity: "Select city",
  selectTimezone: "Select timezone",
  enterCompanyWebsite: "Enter company website",
  requiredField: "This field is required",
  invalidEmail: "Invalid email address",
  invalidCustomEmail: "Invalid {{customEmail}} email",
  invalidUrl: "Invalid URL",
  discard: "Discard",
  save: "Save",
  from: "From",
  to: "To",
  companyDetailsTitle: "Company Details",
  availabilityTitle: "Availability",
  website: "Website",
  companyEmail: "Company Email",
  companyDetailsUpdated: "Company details updated successfully",
  Cancel: "Cancel",
  saveChangesCta: "Save Changes",
  placeHolderType: "Type {{title}}",
  placeholder: "Enter {{field}}",
  placeholderSelect: "Select {{field}}",
  errorField: "{{field}} is required",
  experience: "Experience",
  openForSecondment: "Open for secondment",
  otherDomain: "Other Domain",
  successfullyUpdated: "Domains & subdomains updated successfully",
  removeLogoConfirmMessage: "Are you sure you want to remove your logo?",
  logoRemovedSuccessfully: "Logo removed successfully",

  removeProfilePicConfirmMessage:
    "Are you sure you want to remove your profile picture?",
  profilePicRemovedSuccessfully: "Profile picture removed successfully",
  changeProfilePicture: "Change Profile Picture",
  removeLogo: "Remove Logo",
  removeProfilePic: "Remove Profile Picture",
  catToolsLabel: 'CAT Tools',
  catToolsExperience: 'Do you have experience with CAT Tools?',
  catToolsTitle: 'Select tools or type to add new ones.',
  catToolsPlaceholder: 'Cleverso,...'
};
